import * as actions from '../constants'

const inititalState = {
  loadingPost: true,
  loadingPostError: null,
  creatingComment: false,
  creatingCommentError: null,
  post: null,
  comments: null
}

export default (state = inititalState, action) => {
  switch (action.type) {
    case actions.LOAD_POST_REQUEST:
      return {
        ...state,
        post: null,
        comments: null,
        loadingPost: true,
        loadingPostError: null
      }
    case actions.LOAD_POST_SUCCESS:
      return {
        ...state,
        post: action.payload.post,
        comments: action.payload.comments,
        loadingPost: false,
        loadingPostError: null
      }
    case actions.LOAD_POST_FAILURE:
      return {
        ...state,
        loadingPost: false,
        loadingPostError: action.payload
      }
    case actions.CREATE_COMMENT_REQUEST:
      return {
        ...state,
        creatingComment: true,
        creatingCommentError: null
      }
    case actions.CREATE_COMMENT_SUCCESS:
      let {comment, post} = action.payload
      let comments = state.comments.slice()
      comments.unshift(comment)
      return {
        ...state,
        comments,
        post,
        creatingComment: false,
        creatingCommentError: null
      }
    case actions.CREATE_COMMENT_FAILURE:
      return {
        ...state,
        creatingComment: false,
        creatingCommentError: action.payload
      }
    case actions.CREATE_POST_LIKE_SUCCESS:
    {
      let {post} = action.payload
      return {
        ...state,
        post: state.post._id === post._id?post:state.post,
      }
    }
    case actions.CREATE_COMMENT_LIKE_SUCCESS:
    {
      let {comment} = action.payload
      let comments = state.comments.slice()
      comments.forEach((c, index)=>{
        if(c._id === comment._id){
          comments[index] = comment
        }
      })
      return {
        ...state,
        comments
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/post.js